export default {
	//edmit event传参
	contains: function(parent, child) {
		var parentNode;
		if(child && parent) {
			if(parent === child) {
				return true
			}
			parentNode = child.parentNode;
			while(parentNode) {
				if(parent === parentNode) {
					return true;
				}
				parentNode = parentNode.parentNode;
			}
		}
		return false;
	},
	//获取路由表
	setUro:()=>{
		let url=window.location.pathname;
		return [...(url.split("/"))]
	},
	//时间计算
	goodTime: function(str) {
		let now = new Date().getTime(),
			oldTime = new Date(str).getTime(),
			difference = now - oldTime,
			result = '',
			minute = 1000 * 60,
			hour = minute * 60,
			day = hour * 24,
			halfamonth = day * 15,
			month = day * 30,
			year = month * 12,
			_year = difference / year,
			_month = difference / month,
			_week = difference / (7 * day),
			_day = difference / day,
			_hour = difference / hour,
			_min = difference / minute;
		if(_year >= 1) {
			result = "发表于 " + ~~(_year) + " 年前"
		} else if(_month >= 1) {
			result = "发表于 " + ~~(_month) + " 个月前"
		} else if(_week >= 1) {
			result = "发表于 " + ~~(_week) + " 周前"
		} else if(_day >= 1) {
			result = "发表于 " + ~~(_day) + " 天前"
		} else if(_hour >= 1) {
			result = "发表于 " + ~~(_hour) + " 个小时前"
		} else if(_min >= 1) {
			result = "发表于 " + ~~(_min) + " 分钟前"
		} else result = "刚刚";
		return result;
	},
	//桌面通知
	desknote: function(title = "您有新的消息", content, icon, timeOut = 5000) {
		if(window.Notification) {
			var popNotice = function() {
				if(Notification.permission == "granted") {
					var notification = new Notification(title, {
						body: content,
						icon: icon
					});
					setTimeout(() => notification.close(), timeOut)
				}
			};
			if(Notification.permission == "granted") {
				popNotice();
			} else if(Notification.permission != "denied") {
				Notification.requestPermission(function(permission) {
					popNotice();
				});
			}
		} else {
			console.log('与时俱进的您为什么不更换一个更具时代气息的浏览器呢？');
		}
	}
}


// WEBPACK FOOTER //
// ./src/assets/js/lib.js